import axiosInstance from "auth/FetchInterceptor";
import {
  GET_CREDENTIAL,
  UPSERT_CREDENTIAL,
} from "constants/ApiConstant";

const ApiCredentialService = {};

ApiCredentialService.getApiCredential = function (params) {
  return axiosInstance.post(GET_CREDENTIAL, params);
};

ApiCredentialService.upsert = function (data) {
  return axiosInstance.post(UPSERT_CREDENTIAL, data);
};

export default ApiCredentialService;